<template>
    <div class="text-center">
      <v-dialog v-model="dialog" width="700"> 
  
        <v-card>
          <v-card-title class="text-h5 blue darken-4 white--text">
            Vincular con Oracle NetSuite.
          </v-card-title>
  
          <v-card-text class="py-0 px-2">
            <v-data-table :headers="headers" :items="desserts" :items-per-page="50" :loading="loading_conceptos" disable-pagination hide-default-footer class="elevation-0">
              <template v-slot:[`item.existeNet`]="{ item }">
                <v-badge v-if="item.existeNet" :title="item.existeNet?'Ya existe en netsuite':''" bordered :color="item.existeNet?'green':'white'" :icon="item.existeNet?'mdi-check':''" overlap>
                  <span>  </span>
                  
                </v-badge>
              </template>

              <template v-slot:[`item.opt`]="{ item }">
                <v-checkbox v-model="item.seleccionado" :disabled="item.disabled" />
              </template>
            </v-data-table>
          </v-card-text>
  
          <v-divider></v-divider>
          <v-progress-linear v-if="loading" indeterminate color="green" />
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="loading" color="green" outlined @click="guardar()"> Registrar </v-btn>
            <v-btn :disabled="loading" color="red" outlined @click="dialog = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>

<script>
import xaxios from '@/xaxios';
export default {
  data () {
    return {
      dialog: false,
      loading: false,
      loading_conceptos: false,
      plan: {},
      programa: {},
      headers: [ 
        { text: 'Concepto', value: 'nombre' },
        { text: 'Codigo', value: 'codigo' },
        { text: 'Cuenta netsuite', value: 'cuenta_netsuite' },
        { text: '', value: 'existeNet' },
        { text: ' ', value: 'opt' }, 
      ],
      desserts:[],
      otrosi: "INGRESOS POR OTROS CONCEPTOS",
      enviadosNet: [],
    }
  },
  methods:{
    sacarPrimeraLetra(concepto,cnetsuite,xconcepto_pago_id){
      if(xconcepto_pago_id == 133) return '-CI';
      if(concepto == "Colegiatura") return "C";
      if(concepto == "Mensualidades") return "M";
      if(cnetsuite == this.otrosi) return "-O";
      let letra = concepto.charAt(0);
      return "-"+letra
    },
    getNombre(nombre, cnetsuite){
      if(cnetsuite == this.otrosi) return "OTROS INGRESOS";
      return nombre;
    },
    getConceptoId(concepto_id, cnetsuite){
      if(cnetsuite == this.otrosi) return 0;
      return concepto_id;
    }, 
    verificarExiste2(xcuenta_netsuite_id, xconcepto_pago_id){
      // window.console.log(">>>",xconcepto_pago_id);
      let existe = this.enviadosNet.find(x=>x.cuenta_netsuite_id == xcuenta_netsuite_id && x.concepto_pago_id == xconcepto_pago_id);
      if(existe) return true;
      return false;
    },
    async verificarYaenviado(programa_id){ 
        let url = `${process.env.VUE_APP_API_REST}/api/esam/programa/netsuite/${programa_id}`;
        let res = await xaxios.get(url).then(({data})=>data).catch(e=>e);
        if(!res) res = [];
        return res;
      },
    // async open(plan,programa, sucursal, enviados=[]){
    async open(plan,programa, sucursal){
      // window.console.log(plan,programa,sucursal);
      this.loading = true;
      this.dialog = true;
      this.desserts = [];
      const enviandos = await this.verificarYaenviado(programa.programa_id);
      this.loading = false;
        this.plan = plan;
        this.programa = programa;
        this.enviadosNet = enviandos;
        //window.console.log('plan:::: ',plan.cobros, programa,sucursal);
        if(!sucursal){
          this.$root.$notify.show(`No hay sucursal en el programa`, {color:'red',x: 'right',});
          return;
        }
        if(!programa.codigo){
          this.$root.$notify.show(`El programa no tiene codigo contabilidad`, {color:'red',x: 'right',});
          return;
        }
        
        this.getPreDatos(plan.cobros,programa, sucursal); 
    },
    async getPreDatos(cobros,programa,sucursal){ 
      this.loading_conceptos = true;
      let unidadid = this.$store.state.CARGO.sede.unidad_negocio;
      const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio/unidadnegocio/${unidadid}/nit/${sucursal.nit.id}`;
      let res = await xaxios.get(url).then(({data})=>data).catch((err)=>err);
      window.console.log('>>>>',res);
      
      let conceptos = [];
      // habia objetos nulos, los filtramos
      res.data = res.data.filter(d=>d);
      res.data = res.data.filter(d=>d.cuenta_netsuite);
      res.data.forEach(c=>{ 
        if(!c.cuenta_netsuite) c.cuenta_netsuite = {};
        let idconcepto = c.concepto_pago.id;
        let idcuentanet = c.cuenta_netsuite.id;
        let code = `${programa.codigo}${this.sacarPrimeraLetra(c.concepto_pago.nombre,c.cuenta_netsuite.cuenta,c.concepto_pago_id)}${idconcepto}${idcuentanet}`;
        let sel = cobros.find(pc=>pc.concepto_id==c.concepto_pago_id) != undefined;
        let existN = this.verificarExiste2(c.cuenta_netsuite_id,c.concepto_pago_id);
        conceptos.push({
          xconcepto_pago_id: c.concepto_pago.id,
          nombre: this.getNombre(c.concepto_pago.nombre,c.cuenta_netsuite.cuenta),
          codigo: code,
          cuenta_netsuite: `${c.cuenta_netsuite.cuenta} (${c.cuenta_netsuite.numero})`,
          cuenta_netsuite_id: c.cuenta_netsuite.id,
          seleccionado: sel || existN,
          disabled: sel || existN,
          concepto_pago_id: this.getConceptoId(c.concepto_pago.id,c.cuenta_netsuite.cuenta),
          existeNet: existN
        })
      });
      const inicial = conceptos.find(x=>x.xconcepto_pago_id == 133);

      // window.console.log('getdatataaaa', res.data, this.enviadosNet,conceptos);
      /* const conceptosUnicos = conceptos.filter((obj, index, self) =>
        index === self.findIndex((t) => t.cuenta_netsuite_id === obj.cuenta_netsuite_id)
      ); */

      const otrosingresos = conceptos.find(c=>c.cuenta_netsuite_id == 788 );
      const conceptosUnicos = conceptos.filter(c=>c.cuenta_netsuite_id != 788 ); 
      if(otrosingresos){
        let existe = this.enviadosNet.find(x=>x.cuenta_netsuite_id == 788 && x.concepto_pago_id == 0);
        if(existe) {
          otrosingresos.existeNet = true;
          otrosingresos.disabled = true;
          otrosingresos.seleccionado = true;
        }
        conceptosUnicos.push(otrosingresos);
      }
      if(inicial) {
        inicial.seleccionado = false;
        inicial.disabled = false;
        inicial.existeNet = false;
        const existe = this.enviadosNet.find(x=>x.concepto_pago_id == 133);
        if(existe){
          inicial.seleccionado = true;
          inicial.disabled = true;
          inicial.existeNet = true;
        }
        conceptosUnicos.unshift(inicial)
      }

      conceptosUnicos.sort((a, b) => {
        if (a.existeNet === true && b.existeNet === false) {
          return -1; 
        }
        if (a.existeNet === false && b.existeNet === true) {
          return 1; 
        }
        return 0; 
      });

      this.desserts = conceptosUnicos;
      this.loading_conceptos = false;

    },
    async guardar(){
      this.loading = true;
      let datos = [];
      for(let i=0;i<this.desserts.length;i++){
        let item = this.desserts[i];
        if(!item.seleccionado) continue;
        if(item.existeNet) continue;
        datos.push({ 
          concepto_pago_id: item.concepto_pago_id,
          external_id: item.codigo,
          descripcion: item.nombre,
          cuenta_netsuite_id: item.cuenta_netsuite_id,
        });
      } 

      let send = {
        "programa_id": this.programa.programa_id,
        "servicios_netsuite": datos
      } 

     /*  let a = 1;
      if(a > 0){
        window.console.log(send);
        this.loading = false;
        return;
      } */
      

      const url = `${process.env.VUE_APP_API_REST}/api/esam/programa/netsuite/insertar`;
      let res = await xaxios.post(url,send).then((res)=>res).catch((err)=>err);
      this.loading = false;
      if(res && res.data){
        this.$root.$notify.show(res.data.result, {color:'success',x: 'right',});
        this.dialog = false;
      }else{
        this.$root.$notify.show(res.data, {color:'error',x: 'right',});
      }
    },
  }
}
</script>